var AddToCart = (function ($) {

    var bindAddToCart = function (sel) {
        if (!$(sel).length){
            return;
        }

        $(document).on("click", sel, function(event){
            event.preventDefault();
            var $form = $(event.target).closest("form");
            var code = $form.find("input[name=code]").val();
            var quantity = $form.find(".defaultTiresNumber").val();
            var page = $form.find("input[name=productPage").val();
            if (quantity === undefined) {
                quantity = $(".defaultTiresNumber").val();
            }
            if (quantity === undefined) {
                quantity = $form.find(".tireNumberSelect option:selected, .tireNumberSelect").val();
            }

            if (quantity === undefined) {
                quantity = 1;
            }

            var tyres = [];
            tyres.push({ "code": code, "quantity": quantity, "page" : page });
            var productCartData = {"items": tyres, "price": '', "discountedPrice": '' };

            $.ajax({
                url: "/tyres/addToCart",
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(productCartData.items),
                success: function(data) {
                    $( document ).trigger( "changeCartEvent", productCartData);
                    if (data.entries.length > 0){
                        $(".order-now-container").show();
                        $(".language-selector").hide();
                    }
                },
                error: function(data) {
                    if (data.status === 400 && data.responseJSON && data.responseJSON.error) {
                        $('#limitCartEntriesMessage').text(data.responseJSON.error);
                        $('#limitCartEntriesModal').modal('show');
                        $('#headline').css('z-index', '1030');
                        $('.main-page-header-container').css('z-index', '1030');
                    }
                }
            });
        });
    };

    var bindAddToCartPair = function (sel) {
        $(document).on("click", sel, function(event){

            event.preventDefault();
            var $form = $(event.target).closest("form");
            var frontCode = $form.find("input[name=frontTyreCode]").val();
            var rearCode = $form.find("input[name=rearTyreCode]").val();
            var quantity = 2;

            var tyrePair = [];
            tyrePair.push({ "code": frontCode, "quantity": quantity, "page" : 0 });
            tyrePair.push({ "code": rearCode, "quantity": quantity, "page" : 0 });
            var productCartData = {"items": tyrePair, "price": '', "discountedPrice": '' };

            $.ajax({
                url: "/tyres/addToCart",
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(productCartData.items),
                success: function(data) {
                    $( document ).trigger( "changeCartEvent", productCartData);
                    if (data.entries.length > 0){
                       $(".order-now-container").show();
                       $(".language-selector").hide();
                    }
                }
            });
        });
    };

    var bindListeners = function () {
        //add listener for "add to cart" btn on SERP and PDP
        AddToCart.bindAddToCart(".productListComponent .j-serp-button-buy");
        AddToCart.bindAddToCartPair(".productListComponentPair .j-serp-pair-button-buy");

        //add listener for "add to cart" btn on comparision page
        AddToCart.bindAddToCart("form.addToCartCompareForm .j-serp-button-buy");

        //add listener for "add to cart" btn wishlist tab in my account
        AddToCart.bindAddToCart("form.addToCartForm .add-to-cart-wishitem");

        //add listener for "add to cart" btn on PDP
        AddToCart.bindAddToCart("form.add-to-cart-form button.product-add-button");
        var form = document.querySelector('form.add-to-cart-form');
        if (form !== null) {
            var submitButtons = form.querySelectorAll('.submit_button_warenkorb');

            for (var i = 0; i < submitButtons.length; i++) {
                var button = submitButtons[i];
                if (!button.classList.contains('add-to-cart-disabled-button')) {
                    AddToCart.bindAddToCart("form.add-to-cart-form .submit_button_warenkorb");
                }
            }

            //add listener for "add to cart" btn on home for moto
            AddToCart.bindAddToCart("form.add-to-cart-form button.j-carousel-button-buy");
        }
    };

    return {
        bindListeners: bindListeners,
        bindAddToCart: bindAddToCart,
        bindAddToCartPair: bindAddToCartPair
    };
}) (jQuery);

$(document).ready(function() {
    AddToCart.bindListeners();

    $('.j-cart-limit-entries').submit(function(event) {
        event.preventDefault();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize(),
            error: function(data) {
                if (data.status === 400 && data.responseJSON && data.responseJSON.error) {
                    $('#limitCartEntriesMessage').text(data.responseJSON.error);
                    $('#limitCartEntriesModal').modal('show');
                    $('#headline').css('z-index', '1030');
                    $('.main-page-header-container').css('z-index', '1030');
                }
            }
        });
    });

    $('#limitCartEntriesModal').on('hidden.bs.modal', function() {
        $('#headline').removeAttr('style');;
        $('.main-page-header-container').removeAttr('style');;
    });
});